import { TaxRate } from '@/domain/models/Order/pricePerTax';
import { IMAGE_RULE } from '@/pages/camel-order/sites/service';
import { brand, memo, updatedAt } from '@/pages/menu-managements/const';
import { Title } from '@/pages/menu-managements/services/title';
export type ItemForm = typeof itemForm;

export type BrandItemTakeoutForm = {
  price: string;
  tax_rate: TaxRate;
  pos_code: string;
  pos_code_case_option_group_item: string;
};

export type BrandItemDeliveryForm = {
  price: string;
  tax_rate: TaxRate;
  pos_code: string;
  pos_code_case_option_group_item: string;
};

export type BrandItemEatInForm = {
  price: string;
  tax_rate: TaxRate;
  pos_code: string;
  pos_code_case_option_group_item: string;
};

export const MANAGEMENTITEMLISTACTION_TYPE = {
  NOSELECT: 'NOSELECT',
  DUPLICATE: 'DUPLICATE',
  DELETE: 'DELETE',
} as const;

export type ManagementItemlistActionType =
  keyof typeof MANAGEMENTITEMLISTACTION_TYPE;

const titleJa = {
  key: 'name',
  label: '商品名（表示用）',
} as const;
const image = {
  key: 'image',
  label: '商品画像',
} as const;
const description = {
  key: 'description',
  label: '商品説明',
} as const;
const deliveryPrice = {
  key: 'delivery_price',
  label: '料金・配達',
} as const;
const orderMethod = {
  key: 'order_method',
  label: '提供する注文方式',
} as const;
const isImageSet = {
  key: 'is_image_set',
  label: '画像設定',
} as const;

const categoryNames = {
  key: 'category_names',
  label: 'カテゴリ',
} as const;

const optionGroupNames = {
  key: 'option_group_names',
  label: 'オプショングループ',
} as const;

const action = {
  key: 'action',
  label: 'アクション',
} as const;

export const takeout = {
  price: {
    key: 'takeout_price',
    label: '料金・テイクアウト',
  },
  tax: {
    key: 'takeout_tax',
    label: '消費税率・テイクアウト',
  },
  pos_code: {
    key: 'takeout_pos_code',
    label: 'POSコード・テイクアウト（親商品時）',
  },
  pos_code_case_option_group_item: {
    key: 'takeout_pos_code_case_option_group_item',
    label: 'POSコード・テイクアウト（オプション商品時）',
  },
};
export const delivery = {
  price: {
    key: 'delivery_price',
    label: '料金・デリバリー',
  },
  tax: {
    key: 'delivery_tax',
    label: '消費税率・デリバリー',
  },
  pos_code: {
    key: 'delivery_pos_code',
    label: 'POSコード・デリバリー（親商品時）',
  },
  pos_code_case_option_group_item: {
    key: 'delivery_pos_code_case_option_group_item',
    label: 'POSコード・デリバリー（オプション商品時）',
  },
};
export const eatIn = {
  price: {
    key: 'eat_in_price',
    label: '料金・店内飲食',
  },
  tax: {
    key: 'eat_in_tax',
    label: '消費税率・店内飲食',
  },
  pos_code: {
    key: 'eat_in_pos_code',
    label: 'POSコード・店内飲食（親商品時）',
  },
  pos_code_case_option_group_item: {
    key: 'eat_in_pos_code_case_option_group_item',
    label: 'POSコード・店内飲食（オプション商品時）',
  },
};

export const itemForm = {
  brand,
  titleJa,
  memo,
  image,
  description,
  deliveryPrice,
  takeout,
  delivery,
  eatIn,
  orderMethod,
  action,
} as const;

const tableColumns = [
  {
    ...titleJa,
    width: '200px',
  },
  {
    ...orderMethod,
    width: '160px',
  },
  {
    ...isImageSet,
    width: '160px',
  },
  {
    ...takeout.price,
    width: '140px',
  },
  {
    ...eatIn.price,
    width: '140px',
  },
  {
    ...delivery.price,
    width: '140px',
  },
  {
    ...categoryNames,
    width: '140px',
  },
  {
    ...optionGroupNames,
    width: '140px',
  },
  {
    ...memo,
    width: '180px',
  },
  {
    ...updatedAt,
    width: '180px',
  },
  {
    ...action,
    width: '100px',
  },
] as const;

export const itemTableThs = tableColumns.map((tableColumn) => {
  return {
    label: tableColumn.label,
    minWidth: tableColumn.width,
  };
});

export const validateUploadImageSize = {
  check: (width: number, height: number): boolean => {
    return (
      width < IMAGE_RULE.ITEM_IMAGE.minWidth ||
      height < IMAGE_RULE.ITEM_IMAGE.minHeight
    );
  },
  message: `画像の横幅が ${IMAGE_RULE.ITEM_IMAGE.minWidth} ピクセル以上で、縦幅が ${IMAGE_RULE.ITEM_IMAGE.minHeight} ピクセル以上になるようにしてください。`,
};

export type MenuManagementBrandItem = {
  id: string;
  title?: Title;
  name: string | null;
  image_url: string | null;
  order_methods: string | null;
  takeout_price: number | null;
  eat_in_price: number | null;
  delivery_price: number | null;
  category_names: string | null;
  option_group_names: string | null;
  memo: string | null;
  updated_at: string;
};
